import StartSection from './StartSection'

export {
  StartSection
}


// WEBPACK FOOTER //
// ./src/components/StartSection/index.js